import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { nativeEnum, object, safeParse } from 'valibot';
import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { CustomerNotifications } from 'components/common/customer-notifications';
export const CustomerNotificationTemplateComponent = inject('searchResults')(observer(({
  templateComponent,
  searchResults
}) => {
  const searchCriteria = searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchCriteria;
  const {
    regionId,
    startDate,
    endDate
  } = searchCriteria || {};
  const configSchema = object({
    location: nativeEnum(CustomerNotificationLocation)
  });
  const result = safeParse(configSchema, templateComponent.config);
  if (!result.success) {
    return null;
  }
  const {
    location
  } = result.output;
  return React.createElement(CustomerNotifications, {
    location: location,
    regionId: regionId,
    startDate: startDate,
    endDate: endDate
  });
}));